import { createApp } from 'vue'
import ColpoTable from '../components/ColpoTable.vue';

if (document.getElementById('colpo-review-container')) {
	const colpoReview = createApp({})
	colpoReview.component('ColpoTable', ColpoTable)
	colpoReview.mount('#colpo-review-container')
}